<template>
  <div
    class="media_card image_grid"
    :class="[
      media.length == 2 ? 'two_frame' : media.length == 3 ? 'three_frame' : '',
      showImageViewer ? 'mobile-details-view' : '',
      post && post.repostId ? 'informationPostMediaDv' : '',
    ]"
    v-if="media.length > 1"
  >
    <div class="sliderarrow" v-if="isDetailView || showImageViewer">
      <i
        class="fas fa-chevron-circle-left leftarrow"
        @click="changeIndex(-1)"
        :class="selectedMediaIndex == 0 ? 'd-none' : ''"
      ></i>
      <i
        :class="selectedMediaIndex == media.length - 1 ? 'd-none' : ''"
        @click="changeIndex(1)"
        class="fas fa-chevron-circle-right rightarrow"
      ></i>
    </div>
    <template v-for="(image, index) in media" :key="image">
      <template
        v-if="
          (!isDetailView && !showImageViewer) || index == selectedMediaIndex
        "
      >
        <figure
          @click.stop.prevent="handleShowImageViewer(image)"
          :class="[
            index < 4 ? '' : 'hide',
            !image.type.includes('video')
              ? 'loadingImageContainer adsadad'
              : '',
          ]"
        >
          <LoadingImageWidget
            :imageUrl="image.url"
            v-if="!image.type.includes('video')"
          />
          <video :src="image.url" v-else></video>
          <div class="extraImg" v-if="index == 3 && media.length > 4">
            <span class="count">+{{ media.length - (index + 1) }}</span>
          </div>
        </figure>
      </template>
    </template>
  </div>
  <div
    class="media_card image_frame single_image"
    v-else
    :class="post && post.repostId ? 'informationPostMediaDv' : ''"
  >
    <figure
      @click="handleShowImageViewer(media[0])"
      :class="{ loadingImageContainer: media[0].type.includes('image') }"
    >
      <LoadingImageWidget
        :imageUrl="media[0].url"
        v-if="media[0].type.includes('image')"
      />
      <audio
        controls
        :src="media[0].url"
        v-else-if="media[0].type.includes('audio')"
      ></audio>
      <video controls :src="media[0].url" v-else></video>
    </figure>
  </div>
</template>

<script lang="ts">
import { useUserInterface } from "../../composables/userinterface.composable";
import MediaEntity from "../../models/mediaEntity.model";
import LoadingImageWidget from "./LoadingImageWidget.vue";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  props: ["media", "isDetailView", "showImageViewer", "post"],
  components: {
    LoadingImageWidget,
  },
  setup(props, context) {
    const media = ref<MediaEntity[]>(props.media);
    const { mediaArr, selectedMediaIndex } = useUserInterface();

    onMounted(() => {
      selectedMediaIndex.value = 0;
    });
    const handleShowImageViewer = (item: any) => {
      if (!props.isDetailView) {
        context.emit("showPostDetail");
      }
    };

    const changeIndex = (val: number) => {
      selectedMediaIndex.value = eval(`${selectedMediaIndex.value} + (${val})`);
    };

    return {
      media,
      selectedMediaIndex,
      changeIndex,
      handleShowImageViewer,
    };
  },
});
</script>
<style lang="scss" scoped>
.post_card .body .media_card .image_frame figure .sliderarrow {
  display: none;
}
.post_card .body .media_card .image_grid .sliderarrow {
  display: none;
}
.MediaSingleUploadingGridDv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  .MediaItemInfoDv {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    figure {
      width: 100%;
      height: 300px;
      margin: 0px;
      padding: 0px;
      background: #181326;
      border-radius: 10px;
      img {
        object-fit: contain;
        vertical-align: middle;
        width: 100%;
        border-radius: 10px;
        height: 100%;
      }
    }
    .icon {
      position: absolute;
      right: -12px;
      top: -8px;
      width: 30px;
      height: 30px;
    }
    p {
      font-size: 14px;
      line-height: 1;
      letter-spacing: 0px;
      margin: 0px;
      padding: 0px;
      color: var(--base-text);
    }
  }
}

@media (max-width: 991px) {
  .card--post .body .media_card.image_grid.three_frame {
    &.mobile-details-view {
      display: block;
      position: relative;
      > *:nth-child(2) {
        grid-column-start: 1;
      }
      *::before {
        padding: 0;
      }
      .loadingImageContainer {
        height: calc(100dvh - 300px);
      }
      > .sliderarrow {
        display: block;
        min-height: 100%;
        position: absolute;
        width: 100%;
        margin: 0;
      }

      .sliderarrow {
        > * {
          z-index: 999;
          text-shadow: 0px 1px 4px var(--color-black);
        }

        .leftarrow {
          color: var(--text-color);
          font-size: var(--font-5xl);
          position: absolute;
          left: 20px;
          top: 50%;
        }

        .rightarrow {
          color: var(--text-color);
          font-size: var(--font-5xl);
          position: absolute;
          right: 20px;
          top: 50%;
        }
      }
    }
  }
}

.MediaUploadingGridDv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  margin-top: 20px;
  .MediaItemInfoDv {
    width: 80px;
    height: 80px;
    flex: 0 0 80px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    figure {
      width: 100%;
      height: 100%;
      margin: 0px;
      padding: 0px;
      img {
        object-fit: cover;
        vertical-align: middle;
        width: 100%;
        border-radius: 10px;
        height: 100%;
      }
    }
    .icon {
      position: absolute;
      right: -12px;
      top: -8px;
      width: 30px;
      height: 30px;
    }
    p {
      font-size: 14px;
      line-height: 1;
      letter-spacing: 0px;
      margin: 0px;
      padding: 0px;
      color: var(--base-text);
    }
  }
}
.informationPostMediaDv {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
